import styled from 'styled-components';

export const StyledAddressSection = styled.div`
   display: grid;
   grid-template-columns: 308px 126px 126px;
   grid-template-rows: 66px 66px;
   grid-gap: 24px 36px;
`;
